import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormValidationService {
  isFieldRequired(control: AbstractControl): boolean {
    return control?.errors?.['required'] && control?.touched ? true : false;
  }

  isFieldValid(control: AbstractControl): boolean {
    return control?.valid && (control?.dirty || control?.touched);
  }

  isFieldInvalid(control: AbstractControl): boolean {
    return control?.invalid && (control?.dirty || control?.touched);
  }
}
